import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

//- local
import SuppliersContainer from '../../containers/logistics/Suppliers';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { formatPrimaryContact, isFiltered, sortTable } from '../../libs/utility';
import CheckIcon from '@material-ui/icons/Check';

import { getSharedStyles } from '../../themes';
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
});

const columnData = [
	{ id: 'name', label: 'Name' },
	{ id: 'shortName', label: 'Short Name' },
	{ id: 'primaryContact', label: 'Primary Contact' },
	{ id: 'deliveryEmailList', label: 'Delivery Emails' },
	{ id: 'isQuickbooksLinked', label: 'QB Link' },
	{ id: 'hasScheduleEmails', labels: ['Schedule', 'Emails'] },
	{ id: 'edit', align: 'center', label: 'Edit' },
];

class Suppliers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isViewDialogOpen: false,
			viewStation: {},
			isDcDialogOpen: false,
			dcStation: {},
			order: 'asc',
			orderBy: 'name',
			search: '',
		};

		this.handleEdit = this.handleEdit.bind(this);
		this.handleRequestSort = this.handleRequestSort.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	componentDidMount() {
		if (!this.props.suppliers.length) {
			this.props.searchSuppliers();
		}
	}

	handleSearch(event) {
		this.setState({ search: event.target.value });
	}

	handleEdit(supplierId) {
		this.props.history.push(`/logistics/supplier/update/${supplierId}`);
	}

	handleRequestSort(property) {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	}

	render() {
		const { classes, suppliers, authUser } = this.props;
		const { order, orderBy, search } = this.state;
		if (!suppliers || !authUser) {
			return <div>Fetching suppliers...</div>;
		}
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		//- Filter
		let data = suppliers.reduce((result, supplier) => {
			if (isFiltered({ search, data: supplier, fields: ['name'] })) {
				return result;
			}

			const {
				supplierId,
				name,
				shortName,
				deliveryEmails,
				contacts,
				billingQuickbooksVendorId,
				scheduleEmails,
			} = supplier;

			const isQuickbooksLinked = billingQuickbooksVendorId ? <CheckIcon /> : <div />;

			const primaryContact = formatPrimaryContact(_.first(contacts));

			let deliveryEmailList = (
				<div>
					<i style={{ color: '#999' }}>None</i>
				</div>
			);
			if (deliveryEmails && deliveryEmails.length) {
				deliveryEmailList = (
					<div>
						{deliveryEmails.map((email) => {
							return <div key={email}>{email}</div>;
						})}
					</div>
				);
			}

			const hasScheduleEmails = _.isEmpty(scheduleEmails) ? '-' : <CheckIcon />;

			result.push({
				supplierId,
				name,
				shortName,
				primaryContact,
				deliveryEmailList,
				hasScheduleEmails,
				isQuickbooksLinked,
			});
			return result;
		}, []);

		data = sortTable({ data, order, orderBy });

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>Fuel Vendors and Suppliers</span>
								<TextField
									className={classes.formControl}
									value={this.state.search}
									onChange={(event) => this.handleSearch(event)}
									label="Type to search"
									fullWidth
								/>
							</Typography>
						</Grid>
						{canMakeUpdates && (
							<Grid item xs={4} style={{ textAlign: 'right' }}>
								<Link to="/logistics/supplier/add" style={{ textDecoration: 'none' }}>
									<Button variant="contained" color="primary" className={classes.addButton}>
										ADD SUPPLIER
									</Button>
								</Link>
							</Grid>
						)}
					</Grid>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{data.map((row) => {
									return (
										<TableRow hover className={classes.row} key={row.supplierId}>
											<TableCell>{row.name}</TableCell>
											<TableCell>{row.shortName}</TableCell>
											<TableCell>{row.primaryContact}</TableCell>
											<TableCell>{row.deliveryEmailList}</TableCell>
											<TableCell>{row.isQuickbooksLinked}</TableCell>
											<TableCell>{row.hasScheduleEmails}</TableCell>
											{canMakeUpdates && (
												<TableCell style={{ whiteSpace: 'nowrap' }}>
													<Button
														className={classes.button}
														onClick={() => this.handleEdit(row.supplierId)}
													>
														Edit
													</Button>
												</TableCell>
											)}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

Suppliers.propTypes = {
	classes: PropTypes.object.isRequired,
	searchSuppliers: PropTypes.func.isRequired,
	suppliers: PropTypes.array,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), SuppliersContainer])(Suppliers);
